import React, { useEffect,useState} from "react";
import Top from "../initiator/top.component";
import Bottom from "../initiator/bottom.component";
// import Head from "next/head";
import noInternet from 'no-internet'
// import NoConnection from "@/pages/noconnection";
import { GoogleFonts } from 'nextjs-google-fonts/GoogleFonts'
import { Link } from "react-router-dom";

let myinter = GoogleFonts({
  weight: ['300', '400', '500', '600', '700', '800'],
  subsets: ['latin'],
  display: 'swap'
})

export default function Layout({ children, ...pageProps }) {
  
  const [IsOnline, setOnline] = useState(true);
  useEffect(() => {
    noInternet().then(offline => {
      if (offline) {
        setOnline(false); 
      }
    })
  }, []);
  
  return (
    <>
      {/* <Head> */}
        <title>{pageProps.pageTitle ? pageProps.pageTitle : "Loading..."} | Welcome to GUSD forms</title>
        <meta name="description" content="" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Link rel="icon" to="/Favicon.ico" />
      {/* </Head> */}
      
      {IsOnline ? <><Top reDirectUrl={pageProps.reDirectUrl} reDirectUrlforSA={pageProps.reDirectUrlforSA} allFormsUrl={pageProps.allFormsUrl} IsSuperadmin={pageProps.IsSuperadmin}  IsArchive={pageProps.IsArchive} reDirectUrlforArchive={pageProps.reDirectUrlforArchive}  activeMenu={pageProps.activeMenu ? pageProps.activeMenu :""} appId={pageProps?.appId} /><main className={myinter.className}><div className='pl-[95px] xl:pl-[7.292vw]
       pr-[15px] xl:pr-[3.125vw] xl:pt-[4.792vw]'>{children}</div></main> <Bottom /></> : <>INTERNET CONNECTIVITY ISSUE.</>}
    </>
  );
}
 